/**
*  TheDrawingDialog.vue of project wetrade
*  @date 2022/5/17 20:32
*  @author 阿佑[ayooooo@petalmail.com]
*/
<template>
<div class="mask spread" @click="dismiss">
  <div :style="{top: y - 40 + 'px', left: x ? x + 'px' : '50%' }" class="drawing-dialog p-a" :class="{'bar': type <= LineType.TREND}">
    <div class="df-middle t-center px-8 shadow" style="height: 32px">
      <div class="flex-1" @click.stop="isPicking = !isPicking" style="min-width: 30px"
        v-if="[LineType.LINE, LineType.TREND, LineType.TEXT].indexOf(type)>-1">
        <span class="color-label sm" :style="{background: cColor}" />
        <Icon name="caret-down" class="ml-4 c-tip" sm />
      </div>
      <template v-if="alertOn !== null">
        <span class="c-grey mx-6">|</span>
        <div class="flex-1" @click.stop="toggleAlert">
          <Pic :src="`icons/alert${alertOn ? '' : '_off'}`" width="16" height="16" />
        </div>
        <span class="c-grey mx-6">|</span>
      </template>
      <div v-if="type === LineType.TEXT">
        <span class="c-grey mx-6">|</span>
        <t path="" class="f-sm px-6" @click.stop="editText">Text Editor</t>
        <span class="c-grey mx-6">|</span>
      </div>
      <div class="flex-1" @click.stop="$emit('remove')">
        <Pic src="icons/delete" width="16" height="16" />
      </div>
    </div>
    <ul v-show="isPicking" class="p-a bg-white mt-4 shadow pl-4 py-4" style="width: 148px">
      <li v-for="item in colors" :key="item"
        :style="{background: item}" class="color-label m-4"
        @click.stop="pickColor(item)"
      />
    </ul>
  </div>
</div>
</template>

<script lang="ts">
import Icon from '@/components/Icon.vue'
import Pic from '@/components/Pic.vue'
import { computed, defineComponent, shallowRef, watch } from 'vue'
import { LineType } from '@/modules/market/market.api'

const colors = [
  '#FF1600', '#FF6800', '#FFCB00', '#00FF15', '#00FFFE', '#00B4FF',
  '#0047FF', '#810093', '#A61FFF', '#FF00EF', '#999999', '#000000',
]

export default defineComponent({
  name: 'TheDrawingDialog',
  components: {
    Pic,
    Icon,
  },
  emits: ['color', 'dismiss', 'toggleAlert', 'remove', 'editText'],
  props: {
    y: Number,
    x: Number,
    alertOn: Boolean,
    color: String,
    type: Number,
  },
  setup (props, ctx) {
    const iColor = shallowRef('')
    const cColor = computed(() => iColor.value || props.color)
    const isPicking = shallowRef(false)
    const progress = shallowRef(false)

    watch(() => props.y, () => iColor.value = '')

    const pickColor = (c: string) => {
      iColor.value = c
      isPicking.value = false
      ctx.emit('color', c)
    }

    const toggleAlert = () => {
      if (progress.value) return

      progress.value = true

      ctx.emit('toggleAlert', () => {
        progress.value = false
      })
    }

    const dismiss = () => {
      isPicking.value = false

      if (!progress.value) ctx.emit('dismiss')
    }

    const editText = () => {
      ctx.emit('editText')
    }

    return {
      cColor,
      colors,
      isPicking,
      progress,
      pickColor,
      toggleAlert,
      dismiss,
      editText,
      LineType,
    }
  },
})
</script>

<style scoped lang="scss">
.bar {
  left: 50%;
  transform: translateX(-50%);
}

.shadow {
  background: var(--color-white);
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(10, 31, 68, 0.5);
}

.color-label {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  border-radius: 2px;

  &.sm {
    width: 10px;
    height: 10px;
  }
}
</style>
